import { render, staticRenderFns } from "./SettingsLanguage.vue?vue&type=template&id=4e2b4211&scoped=true&"
import script from "./SettingsLanguage.vue?vue&type=script&lang=js&"
export * from "./SettingsLanguage.vue?vue&type=script&lang=js&"
import style0 from "./SettingsLanguage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SettingsLanguage.vue?vue&type=style&index=1&id=4e2b4211&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2b4211",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e2b4211')) {
      api.createRecord('4e2b4211', component.options)
    } else {
      api.reload('4e2b4211', component.options)
    }
    module.hot.accept("./SettingsLanguage.vue?vue&type=template&id=4e2b4211&scoped=true&", function () {
      api.rerender('4e2b4211', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nav/settings/SettingsLanguage.vue"
export default component.exports